export const FormDivider = () => (
  <div className="w-full border-t border-slate-200" />
);
